<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar></NavBar>
        <div class="form-steps">
            <!-- First Step -->
            <div class="form-steps__step form-steps__step--active">
                <div class="form-steps__step-circle">
                <span class="form-steps__step-number">1</span>
                <span class="form-steps__step-check">&#x2713;</span>
                </div>
                <span class="form-step__step-name">選擇課程</span>
            </div>
            <!-- Second Step -->
            <div class="form-steps__step form-steps__step--last">
                <div class="form-steps__step-circle">
                <span class="form-steps__step-number">2</span>
                <span class="form-steps__step-check">&#x2713;</span>
                </div>
                <span class="form-step__step-name">選擇時間及老師</span>
            </div>
        </div>

        <h5 class="p-2">課程列表</h5>
        <hr />
        <!--choosing lesson-->
        <div class="p-2 LessonList">
            <ul class="nobull">
                <li v-for="Lesson in LessonObjects" >
                    <input type="radio" name="Lesson" @click="ChooseLesson(Lesson)"> {{Lesson}}
                    <hr />
                </li>
            </ul>
            <span>{{NoLessonNote}}</span>
        </div>

        <div class="d-flex justify-content-between p-2 footerNAV">
            <button class="ShareBTN"><router-link :to="`/index`">取消訂課</router-link></button>
            <button class="ShareBTN" @click="ToBookingTeacher()">下一步</button>

            
        </div>

    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'BookingLesson',
    components:{
        NavBar
    },
    data () {
        return {
            LessonObjects:[],
            SelectedLesson:null,
            Token:'',
            LessonType:'',
            languageType:'',
            NoLessonNote:'',
            showLoading:false,
        }
    },
    methods:{
        ChooseLesson(Lesson){
            this.SelectedLesson = Lesson;
        },
        //取得已訂課清單
        GetCanBookingLessons(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Student/GetCanBookingLessons`;
            const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata = 
            {
                // "LessonType": parseFloat(this.LessonType) ,
                // "languageType": parseFloat(this.languageType)
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                     if(response.data.Result){
                        if(response.data.LessonObjects == undefined){
                            this.NoLessonNote ='無課程可選擇！';
                            this.LessonObjects = [];
                        }
                        else{
                            this.LessonObjects = response.data.LessonNames;
                        }
                    }else{
                        if(response.data.errorCode == 20002){
                            alert("閒置時間過長，請重新進入。");
                        }
                        this.NoLessonNote ='無課程可選擇！';
                        this.LessonObjects = [];
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("取得課程失敗："+ error.message);
                });
        },

        //下一步
        ToBookingTeacher(){
            if(this.SelectedLesson != null || this.SelectedLesson != undefined ){
                this.$router.push({
                    name: 'BookingTeacher',
                    params: { 
                        Lesson: this.SelectedLesson,
                    }
                });
            }else{
                //請選擇課程
                alert("請選擇課程!!")
            }
        },
    },    
    created(){
        this.Token = sessionStorage.getItem('Token');
        this.GetCanBookingLessons();
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/BookingLesson.vue